import api from "@/api/axios/axios.js";


export async function calculateUsage() {
    const resp = await api.get("/calculateApi/usage/");
    return resp;
}

export async function getUsageHistory() {
    const resp = await api.get("/calculateApi/usage/history/");
    return resp
}

export async function getUsersLimit(){
    const resp= await api.get("/calculateApi/admin/users/");
    return resp
}

export async function updateLimitUser(u, nuevoLimite){
    const resp= await api.patch(`/calculateApi/admin/users/${u.id}/limit/`, {
      limit_usd: nuevoLimite,
    });
    return resp
}

export async function deletedUsageUser(u){
    const {data}= await api.post(`/calculateApi/admin/users/${u.id}/reset/`);
    return data
}


export async function calculateUsageUnit() {
    const resp = await api.get("/calculateApi/admin/units/");
    return resp;
}

// Fija el presupuesto (limite_usd) de una unidad. limiteUsd = número o null (quita el tope).
// El backend responde 400 si el límite queda por debajo de lo ya repartido (asignado).
export async function setUnitLimit(unidadId, limiteUsd) {
    const resp = await api.patch(`/calculateApi/admin/units/${unidadId}/limit/`, {
        limite_usd: limiteUsd,
    });
    return resp.data;
}

// Reinicia el consumo de TODOS los usuarios de la unidad (libera límites + "gastado").
// Conserva ConsumoMensual.
export async function resetUnit(unidadId) {
    const resp = await api.post(`/calculateApi/admin/units/${unidadId}/reset/`);
    return resp.data;
}
